import { createApp } from "vue/dist/vue.esm-bundler";
import debounce from "debounce";
import * as focusTrap from "focus-trap";

const body = document.getElementsByTagName("body")[0];

const menuData = menuItemData;

//Main Menu
const app = createApp({
  delimiters: ["${", "}"],
  data: function () {
    return {
      ...menuData,
      menuOpen: false,
      offcanvasTrap: null,
      dropdowns: null,
      mainNavItems: null,
    };
  },
  created: function () {
    window.addEventListener("resize", debounce(this.resize, 200), {
      passive: true,
    });
  },
  mounted: function () {
    this.offcanvasTrap = focusTrap.createFocusTrap(
      "#js-siteHeader__container",
      {
        clickOutsideDeactivates: true,
      }
    );
    this.dropdowns = document.querySelectorAll(".accordionNav__dropdown-js");
    this.mainNavItems = document.querySelector("#primaryNav__items-js");
    this.setDropdownWidths();
  },
  destroyed() {
    window.removeEventListener("resize", debounce(this.resize, 200));
  },
  watch: {
    menuOpen: function (value) {
      body.classList.toggle("u-noScroll");
      value ? this.offcanvasTrap.activate() : this.offcanvasTrap.deactivate();
    },
  },
  methods: {
    resize() {
      this.setDropdownWidths();
    },
    setDropdownWidths() {
      let width,
        mainNavBox = this.mainNavItems.getBoundingClientRect();
      this.dropdowns.forEach((dropdown) => {
        let box = dropdown.getBoundingClientRect();
        if (dropdown.classList.contains("accordionNav__subItems--right")) {
          width = box.right - mainNavBox.left;
        } else width = mainNavBox.right - box.left;

        dropdown.style.setProperty("--dropdown-width", width + "px");
      });
    },
    afterEnter() {
      this.offcanvasTrap.activate();
      //this.$refs.firstNavItem.focus();
    },
    afterLeave() {
      this.offcanvasTrap.deactivate();
      //this.$refs.offCanvasMenu__trigger.focus();
    },
  },
});
app.mount("#js-siteHeader");
